/**
 * Приглашения на стороне приложения.
 *
 * Доля приглашающего платится контрактом, а не сервером: 40% удержанной
 * комиссии уходит на его адрес при закрытии сделки. Приложению остаётся
 * донести до контракта две вещи — адрес приглашающего и подпись протокола
 * над парой «приглашающий — покупатель».
 *
 * Подпись нужна именно из-за второй половины пары: без неё покупатель привёл
 * бы сам себя со второго кошелька, и контракт не смог бы этого различить —
 * на цепочке два адреса одного человека выглядят как два разных человека.
 */

import { fetchReferralCert, recordReferralVisit } from './api.ts';
import { getInitData, getReferralCode } from './telegram.ts';

export interface Invitation {
  referrer: string;
  signature: string;
}

/**
 * Приглашение для предоплаты — или ничего.
 *
 * Никогда не бросает и никогда не задерживает покупку из-за себя: отказ
 * сервера, отсутствие ссылки, недоступная сеть — всё это означает обычную
 * покупку без приглашения, а не ошибку. Деньги важнее ссылки.
 */
export async function resolveInvitation(myAddress: string): Promise<Invitation | undefined> {
  const code = getReferralCode();
  const initData = getInitData();
  if (code === '' || initData === '' || myAddress === '') return undefined;

  try {
    const res = await fetchReferralCert({ initData, address: myAddress, code });
    return res.ok ? { referrer: res.referrer, signature: res.signature } : undefined;
  } catch {
    return undefined;
  }
}

/**
 * Ссылка-приглашение.
 *
 * Без короткого имени приложения: у бота включён Main Mini App, и открывает
 * его именно `t.me/<бот>?startapp=…`. Форма с `/app` требует отдельного
 * приложения с таким коротким именем — такого у нас нет, и ссылка вела бы в
 * никуда. Проверено по getMe: has_main_web_app.
 *
 * Без имени бота собрать ссылку неоткуда — тогда показывается код.
 */
export function invitationLink(bot: string | null, code: string): string | null {
  return bot === null || bot === '' ? null : `https://t.me/${bot}?startapp=ref_${code}`;
}

/**
 * Сообщает о переходе по ссылке — один раз за запуск.
 *
 * Никогда не мешает работе приложения: отказ, отсутствие ссылки или
 * недоступная сеть означают только, что переход не засчитан.
 */
export async function reportReferralVisit(): Promise<void> {
  const code = getReferralCode();
  const initData = getInitData();
  if (code === '' || initData === '') return;
  try {
    await recordReferralVisit({ initData, code });
  } catch {
    // Отметка — не условие работы, а наблюдение за ней.
  }
}
